import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const RhodeIsland = () => {
  return (
    <StatePropertyTaxPage
      stateName="Rhode Island"
      processDescription="Property owners may appeal their assessment by filing with the local board of assessment review within 90 days of the mailing of the tax bill, or with the state property tax appeal board. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="July"
      noticeOfValueMailedDateExplanation="Tax bills containing assessment information are typically mailed in July."
      valuationAsOfDate="December 31"
      valuationAsOfDateExplanation="Rhode Island assesses property as of December 31 of the prior year. This year-end assessment date captures property values at the close of the previous calendar year."
      deadlineExplanation="Property owners have 90 days from the mailing of the tax bill to file appeals with the local board of assessment review. This typically results in an October deadline."
    />
  );
};

export default RhodeIsland;